import { Button, Stack, Typography } from "@mui/material"
import { Frame } from "../../components/layouts/Frame"
import { DataTable } from "../../components/global/Table/DataTable"
import { Link } from "../../components/global/Link";
import { EditIcon } from "../../assets/svgs/EditIcon";
import { Route, Routes, useNavigate } from "react-router-dom";
import { AddSector } from "./AddSector";
import { EditSector } from "./EditSector";
import { DataTableHeadCellData } from "../../components/global/Table/DataTableHeader";
import { SectorIcon } from '../../assets/svgs/SectorIcon';
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../assets/contexts/AuthContext";
import { useAPI } from "../../hooks/useAPI";
import { SectorData } from "../../types";

const headCells: DataTableHeadCellData[] = [
  {
    id: 'name',
    disablePadding: true,
    label: 'Name',
    align: 'left',
    sortable: true,
    searchable: true,
  },
  {
    id: 'edit',
    disablePadding: false,
    label: 'Edit',
    width: '50px',
  },
];

interface SectorTableData {
  id: any;
  name: any;
  edit: JSX.Element;
}

export const Sectors = () => {
  const navigate = useNavigate();
  const isLoading = useRef(false);
  const [sIsLoading, setSIsLoading] = useState(false);
  const { isAuthenticated } = useAuth();
  const { fetchData } = useAPI();
  const [rows, setRows] = useState<SectorTableData[]>([]);

  const onAddSector = () => {
    navigate('/sectors/create');
  }

  const onBulkDelete = async (ids: number[]) => {
    await fetchData('/sectors/delete',  { id: ids }, 'POST');
    refetchSectors();
  }

  const refetchSectors = async () => {
    setSIsLoading(true);
    isLoading.current = true;
    const {errors, data} = await fetchData('/sectors/all');
    setRows(getRows(data ?? []));
    isLoading.current = false;
    setSIsLoading(false);
  }

  const getRows = (sectors: SectorData[]) => {
    const result: SectorTableData[] = [];
    for (let i=0; i<sectors.length; i++) {
      result.push({
        id: `${sectors[i].id}`,
        name: <Typography>{sectors[i].name}</Typography>,
        edit: <Link to={`/sectors/${sectors[i].id}`}><EditIcon /></Link>
      });
    }
    return result;
  }

  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      refetchSectors();
    }
  }, [isAuthenticated]);

  return (
    <Frame title="sectors" toolbarButtons={(
      <>
        <Button variant="contained" onClick={onAddSector} startIcon={<SectorIcon width="22" height="15" color="#FFFFFF" />}>
          Add Sector
        </Button>
      </>
    )}>
      <Stack>
        <Routes>
          <Route
            path="/create/"
            element={<AddSector refetchSectors={refetchSectors} />}
          ></Route>
          <Route
            path="/:sector_id/"
            element={<EditSector refetchSectors={refetchSectors} />}
          ></Route>
        </Routes>
        <DataTable headCells={headCells} rows={rows} onBulkDelete={onBulkDelete} isLoading={sIsLoading} title="Sectors" />
      </Stack>
    </Frame>
  )
}
